<div class="wrapper">
  <img src="/assets/images/no-results.svg" alt="No results" />
  <h4>{{ title }}</h4>
  <p>{{ message }}</p>
</div>
